import { render, staticRenderFns } from "./project-organizations.html?vue&type=template&id=565d9841&"
import script from "./ProjectOrganizations.vue?vue&type=script&lang=js&"
export * from "./ProjectOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports